export default "__VITE_ASSET__ad34a312__"